import * as React from "react";
import { Waypoint } from "react-waypoint";
import ProductListItem from "@components/ProductListItem";
import { RootState, useAppDispatch } from "@services/Redux";
import { useSelector } from "react-redux";
import { CompanyBanner, CompanyHeader } from "./components";
import Styled from "./styled";
import LoadingSpinner from "react-spinners/SyncLoader";
import Loading from "@components/Loading";
import ProductsFilters from "@components/ProductsFilter";
import { fetchProducts, setProductsFilterCurrentPage } from "@services/Redux/products";

const CompanyScreen: React.FC = () => {
  const company = useSelector((state: RootState) => state.company);
  const selectedProduct = useSelector((state: RootState) => state.app.selectedProduct);
  const { filters, products, loading: loadingProducts, count: productsCount } = useSelector((state: RootState) => state.products);
  const noMoreResults = filters.currentPage >= Math.ceil(productsCount / 10);
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if (selectedProduct) return;
    dispatch(fetchProducts());
  }, []);

  React.useEffect(() => {
    if (!selectedProduct) return;
    const el = document.getElementById(`product_item_${selectedProduct.id}`);
    const topOfElement = el?.getBoundingClientRect().top ?? 0;
    const top = topOfElement - 100;
    // Using any because behavior 'instant' is not available in React.
    window.scrollTo({ top, behavior: "auto" } as ScrollToOptions);
    // eslint-disable-next-line
  }, []);

  const handleLoadMoreProducts = () => {
    dispatch(setProductsFilterCurrentPage(filters.currentPage + 1));
    dispatch(fetchProducts());
  };

  if (company.loading || (loadingProducts && filters.currentPage === 1)) return <Loading />;

  return (
    <div>
      <CompanyHeader />
      <div style={{ marginTop: 50 }}>
        <ProductsFilters />
        <CompanyBanner />
        <Styled.RootContainer id="products-container">
          <Styled.ProductsContainer className={"py-3"}>
            <div className={"row no-gutters p-0 m-0"}>
              {products.map((product) => (
                <div className={"col-6 col-md-4 col-lg-3 mb-4"} key={product.id}>
                  <ProductListItem product={product} />
                </div>
              ))}
              <Waypoint
                onEnter={() => {
                  if (products.length > 0 && !loadingProducts && filters.currentPage < Math.ceil(productsCount / 10)) {
                    handleLoadMoreProducts();
                  }
                }}
              />
            </div>
          </Styled.ProductsContainer>
          <div className={"mb-4"}>
            {loadingProducts && (
              <div className={"d-flex justify-content-center mb-4"}>
                <LoadingSpinner size={10} />
              </div>
            )}
            {noMoreResults && !loadingProducts && (
              <div className={"d-flex justify-content-center"}>
                <span>sem mais resultados</span>
              </div>
            )}
          </div>
        </Styled.RootContainer>
      </div>
    </div>
  );
};

export default CompanyScreen;
